import base from '@/__vue2stone/service/wasaapi/v1/__base';

export default {
  async index(choiceGroupId, params) {
    const res = await base.index({
      parentName: 'common_choice_group',
      parentId: choiceGroupId,
      modelName: 'common_choice',
      params,
    });
    return res;
  },
  async create(choiceGroupId, data) {
    const res = await base.create({
      parentName: 'common_choice_group',
      parentId: choiceGroupId,
      modelName: 'common_choice',
      data,
    });
    return res;
  },
  async show(choiceId) {
    const res = await base.show({
      modelName: 'common_choice',
      modelId: choiceId,
    });
    return res;
  },
  async update(choiceId, data) {
    const res = await base.update({
      modelName: 'common_choice',
      modelId: choiceId,
      data,
    });
    return res;
  },
  async delete(choiceId) {
    const res = await base.delete({
      modelName: 'common_choice',
      modelId: choiceId,
    });
    return res;
  },
  async updateSequence(choiceGroupId, data) {
    const res = await base.create({
      parentName: 'common_choice_group',
      parentId: choiceGroupId,
      modelName: 'update/choice/sequence',
      data,
    });
    return res;
  },
}